export const globalConfig: {
  globalNodes: HTMLElement[]
} = {}
export let globalConfigIsFrozen = false

export function freezeGlobalConfig() {
  globalConfigIsFrozen = true
}
